import React from 'react'
import { I18n, hooks } from '@front/volcanion'

import { TableCell } from '@mui/material'

import FormatUtils from '@front/squirtle/utils/format'

import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row }) => {
  const [{ name: operator_name }] = hooks.useCustomerInfo(row?.operator?.user_id)
  return <>
    <TableCell size={'small'}><TextCell value={FormatUtils.formatDateBackToFront(_.get(row, 'createdAt'))} /></TableCell>
    <TableCell size={'small'}><TextCell value={operator_name} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'group.group_client_id')} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'license.license_client_id')} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'driver.info.user_client_id')} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'vehicle.info.plaque')} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'rubric.name_translated')} /></TableCell>
    <TableCell size={'small'}><TextCell value={!!_.get(row, 'name') && I18n.t(`event.${_.get(row, 'name')}`)} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'infos')} /></TableCell>
  </>
}

export default React.memo(Row)
